export default __webpack_public_path__ + "static/media/discover_logo.3e69ac64.svg";